import { COLORS, timing, variantForLevel, } from './params';
const FEEDBACK_MS = timing.feedbackMs;
function pickRandom(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}
function pickRandomExcept(arr, excl) {
    const filtered = arr.filter((x) => x !== excl);
    return filtered[Math.floor(Math.random() * filtered.length)];
}
export function makeStimulus(trialIdx, durationMs, level) {
    const variant = variantForLevel(level);
    const palette = COLORS.slice(0, Math.min(variant.nColors, COLORS.length));
    // Pour MVP nColors > 4 on reste sur 4 couleurs réelles (limite design tokens).
    // Génère mot gauche + encre gauche (potentiellement incongruents pour pollution lecture).
    const leftWord = pickRandom(palette);
    const leftInkIncongruent = Math.random() < 0.6; // ~60% incongruent au gauche pour conflit lecture
    const leftInk = leftInkIncongruent ? pickRandomExcept(palette, leftWord) : leftWord;
    // Mot droit : sa signification est la cible à matcher contre l'encre gauche.
    const isMatch = Math.random() >= variant.incongruentRate;
    const rightWord = isMatch ? leftInk : pickRandomExcept(palette, leftInk);
    const rightInkIncongruent = Math.random() < 0.6;
    const rightInk = rightInkIncongruent ? pickRandomExcept(palette, rightWord) : rightWord;
    return {
        trialIdx,
        durationMs: Math.max(timing.minRenderMs, durationMs),
        leftWord,
        leftInk,
        rightWord,
        rightInk,
        expectedMatch: leftInk === rightWord,
    };
}
export function createColorMatchAdapter(level = 1) {
    let state = {
        subPhase: 'idle',
        stim: null,
        feedback: null,
        level,
        variant: variantForLevel(level),
    };
    const listeners = new Set();
    let resolver = null;
    let rejecter = null;
    let trialStart = 0;
    const timers = [];
    function clearTimers() {
        while (timers.length > 0) {
            const t = timers.pop();
            if (t !== undefined)
                clearTimeout(t);
        }
    }
    function update(patch) {
        state = { ...state, ...patch };
        for (const l of listeners) {
            try {
                l(state);
            }
            catch {
                /* ignored */
            }
        }
    }
    return {
        mount() { },
        unmount() {
            clearTimers();
            listeners.clear();
            if (rejecter) {
                rejecter(new Error('unmount'));
                rejecter = null;
                resolver = null;
            }
        },
        presentStimulus(stim) {
            clearTimers();
            return new Promise((resolve, reject) => {
                resolver = resolve;
                rejecter = reject;
                update({ subPhase: 'fixation', stim, feedback: null });
                timers.push(setTimeout(() => {
                    update({ subPhase: 'awaiting_response' });
                    trialStart = Date.now();
                    // Timeout du SOA → miss (correct=false).
                    timers.push(setTimeout(() => {
                        if (resolver) {
                            const r = resolver;
                            resolver = null;
                            rejecter = null;
                            r({
                                pick: false,
                                correct: false,
                                reactionTimeMs: stim.durationMs,
                                timedOut: true,
                            });
                        }
                    }, stim.durationMs));
                }, timing.fixationMs));
            });
        },
        async showFeedback(correct) {
            update({ subPhase: 'feedback', feedback: correct ? 'correct' : 'incorrect' });
            await new Promise((resolve) => {
                timers.push(setTimeout(() => {
                    update({ subPhase: 'iti' });
                    resolve();
                }, FEEDBACK_MS));
            });
        },
        pause() { },
        resume() { },
        abort() {
            clearTimers();
            if (rejecter) {
                rejecter(new Error('aborted'));
                rejecter = null;
                resolver = null;
            }
        },
        getState() {
            return state;
        },
        subscribe(listener) {
            listeners.add(listener);
            listener(state);
            return () => {
                listeners.delete(listener);
            };
        },
        handlePick(pick) {
            if (state.subPhase !== 'awaiting_response')
                return;
            const stim = state.stim;
            if (!stim)
                return;
            const correct = pick === stim.expectedMatch;
            const rt = Date.now() - trialStart;
            const resp = { pick, correct, reactionTimeMs: rt, timedOut: false };
            if (resolver) {
                const r = resolver;
                resolver = null;
                rejecter = null;
                // Cancel pending timeout.
                clearTimers();
                r(resp);
            }
        },
        setLevel(newLevel) {
            const v = variantForLevel(newLevel);
            update({ level: newLevel, variant: v });
        },
    };
}
export const COLOR_NAME_FR = {
    rouge: 'ROUGE',
    bleu: 'BLEU',
    vert: 'VERT',
    jaune: 'JAUNE',
};
//# sourceMappingURL=adapter.js.map